/**
 *
 * Generate a CSV with given rows.
 *
 * eg:
 *  const rows = [
 *    ['id', 'name', 'price'],
 *    ['123', 'Iphone', '250$']
 *    ['456', 'MacBook', '1250$']
 *  ]
 */
export function generateAndDownloadCSV({
  rows,
  filename = 'generated-file',
  delimiter = ';',
}: {
  rows: (string | number)[][]
  filename?: string
  delimiter?: ';' | ','
}) {
  const csvContent = rows.map((e) => e.join(delimiter)).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const pom = document.createElement('a')

  pom.href = url
  pom.setAttribute('download', `${filename}.csv`)
  pom.click()
}
